import { ApolloClient, InMemoryCache, gql } from "@apollo/client";
import { createUploadLink } from "apollo-upload-client";

import { getToken, getId } from "./auth";

import config from "../config";

const baseURL = config.REACT_APP_API_GRAPHQL_URL;

const uploadLink = createUploadLink({
  uri: baseURL,
  headers: {
    authorization: `Bearer ${getToken()}`,
    userid: `${getId()}`,
  },
});

const client = new ApolloClient({
  link: uploadLink,
  cache: new InMemoryCache(),
});

export default client;
